export default {
  path: '/lvy-human-service-0818',
  component: () => import('./LVYHumanService'),
  meta: {
    title: '1V1精准牵线',
    designWidth: 750,
    expireIn: 'Thu Dec 31 2099 08:00:00 GMT+0800 (China Standard Time)',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
